import { HandlerService } from '@app/_services/handler.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ResponseMain } from '@app/_interfaces/responses';
import { MAIN_DOMAIN } from '@app/app.constants';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

export class APIService {
    private destroy$: Subject<boolean> = new Subject<boolean>();
    apiUrl: string = `${MAIN_DOMAIN}/api/`;

    constructor(private http: HttpClient, private handlerService: HandlerService) {}

    get(url: string): Observable<any> {
        return this.http
            .get<ResponseMain>(`${this.apiUrl}${url}`)
            .pipe(takeUntil(this.destroy$))
            .pipe(
                map((next: any) => {
                    // console.log('%c GET: ' + `%c ${url} \n`, 'color: green', 'color: #219ebc', next);
                    this.handlerService.checkErrors(next);
                    return next;
                })
            );
    }

    post(url: string, data: any): Observable<any> {
        return this.http
            .post<any>(`${this.apiUrl}${url}`, data)
            .pipe(takeUntil(this.destroy$))
            .pipe(
                map((next: any) => {
                    // console.log('%c POST: ' + `%c ${url} \n`, 'color: green', 'color: #219ebc', next);
                    this.handlerService.checkErrors(next);
                    return next;
                })
            );
    }

    patch(url: string, data: any): Observable<any> {
        return this.http
            .patch<any>(`${this.apiUrl}${url}`, data)
            .pipe(takeUntil(this.destroy$))
            .pipe(
                map((next: any) => {
                    // console.log('%c PATCH: ' + `%c ${url} \n`, 'color: green', 'color: #219ebc', next);
                    this.handlerService.checkErrors(next);
                    return next;
                })
            );
    }

    delete(url: string): Observable<any> {
        return this.http
            .delete<any>(`${this.apiUrl}${url}`)
            .pipe(takeUntil(this.destroy$))
            .pipe(
                map((next: any) => {
                    // console.log('%c DELETE: ' + `%c ${url} \n`, 'color: green', 'color: #219ebc', next);
                    this.handlerService.checkErrors(next);
                    return next;
                })
            );
    }
}
